import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    marginBottom: 40,
    backgroundColor: '#cdf7ff',
    height: 40,
  },
});
